(function() {
  'use strict';
  angular.module('eva2-angular').service('windowsNavigator', function() {
    return {userAgent: navigator.userAgent};
  });
})();
